import React from "react";
import { ButtonGroup, Button } from "reactstrap";
import {
  ContestCategories,
  ContestCategory,
} from "../../utils/ContestClassifier";

interface Props {
  active: ContestCategory;
  setActive: (next: ContestCategory) => void;
}

export const TableTabButtons: React.FC<Props> = (props) => {
  const { active, setActive } = props;

  return (
    <ButtonGroup className="table-tab">
      {ContestCategories.filter((c) => c !== "Heuristic").map((category) => (
        <Button
          key={category}
          color="secondary"
          onClick={(): void => {
            setActive(category);
          }}
          active={active === category}
        >
          {category}
        </Button>
      ))}
    </ButtonGroup>
  );
};
